import { Component, Input, SimpleChanges, forwardRef, Output, EventEmitter } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { EoDropdownComponent } from 'ngx-eo-web-components';
import { ClinicService } from '../../../../services/clinic/clinic.service';
import { STATUS } from '../../../core/models/loading-status.enum';
import { Clinic } from '../../../core/models/clinic.model';

@Component({
  selector: 'app-clinic-dropdown',
  templateUrl: './clinic-dropdown.component.html',
  styleUrls: ['./clinic-dropdown.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ClinicDropdownComponent),
      multi: true,
    },
  ],
})
export class ClinicDropdownComponent extends EoDropdownComponent<Clinic> {
  @Input() override label = 'Κλινική';
  @Input() override optionLabel = 'clinicName';
  @Input() override optionValue = 'id';
  @Input() override placeholder = 'Όλες οι κλινικές';
  @Input() override filterPlaceholder = 'Αναζήτηση με όνομα';
  @Input() override filterBy = 'clinicName';

  override options: Clinic[] = [];
  clinicListByHospitalCallHandler = this.clinicService.clinicListByHospitalCallHandler;

  @Input() hospitalId?: string | null;

  constructor(private readonly clinicService: ClinicService) {
    super();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['hospitalId']) {
      const newValue = changes['hospitalId'].currentValue;
      if (!newValue) {
        this.clearOptions();  // Clear options if hospitalId is cleared
      } else {
        this.getClinics();    // Fetch clinics if hospitalId is provided
      }
    }
  }

  override ngOnInit() {
    this.getClinics();
  }

  getClinics() {
    if (!this.hospitalId) {
      this.clearOptions();  // Clear options if no hospital ID is provided
      return;
    }
    this.clinicService.getClinicsByHospitalId(this.hospitalId).subscribe((data) => {
      this.options = data;
    });
  }

  clearOptions() {
    this.options = [];
  }

  override hasFilter(): boolean {
    return true;
  }

  override isLoading(): boolean {
    return this.clinicListByHospitalCallHandler.status$.getValue() === STATUS.loading;
  }
}
